import React, { Component } from "react"
import { withTranslation } from 'react-i18next';
import { GlobalContext } from "../context/GlobalContext";

import MobileNumUpdate from "./ProfileUpdateScreens/MobileNumUpdate"
import EmailAndCityUpdate from "./ProfileUpdateScreens/EmailAndCityUpdate"
import IDNumAndNationality from "./ProfileUpdateScreens/IDNumAndNationality"
import ActiveVoiceLines from "./ProfileUpdateScreens/ActiveVoiceLines"
import ActivationCode from "./ProfileUpdateScreens/ActivationCode"
import AbsherOtp from "./ProfileUpdateScreens/AbsherOtp"

class ProfileUpdate extends Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    const profileUname = window.userName;
    const [context] = this.context;
    const { stepValue, profileUpdateScreen } = context

    return (
      <div className="profileUpdate">
        <div className="pu_step_info">{`${t('step')} ${t(stepValue)} ${t('of')} ${t('three')}`}</div>

        <div className="pu_welcome_text">{t("welcome_user") + " " + profileUname + "!"} </div>
        <div className="pu_heading">{stepValue === 'three' ? t("bidding_text") : t("contactdetails_text")}</div>

        <div>
          {profileUpdateScreen === "MobileNumUpdate" && <MobileNumUpdate />}
          {profileUpdateScreen === "ActivationCodeScreen" && <ActivationCode />}
          {profileUpdateScreen === "EmailAndCityUpdate" && <EmailAndCityUpdate />}
          {profileUpdateScreen === "IDNumAndNationality" && <IDNumAndNationality />}
          {profileUpdateScreen === "ActiveVoiceLines" && <ActiveVoiceLines />}
          {profileUpdateScreen === "AbsherOtp" && <AbsherOtp />}
        </div>
      </div>
    )
  }
}

export default withTranslation()(ProfileUpdate);